import { updateUserThemeSettingRpc } from '../../../../__generated__/chirp/com/hubspot/frontend/app/usersettings/rpc/UserSettingsRpc';
import { hubfulRpcClient } from '../../../utils/API';
const getEnumFromTheme = (themeName, themeMode) => {
  if (themeName === 'trellis' && themeMode === 'light') {
    return 'TRELLIS_LIGHT';
  } else if (themeName === 'canvas' && themeMode === 'light') {
    return 'CANVAS_LIGHT';
  }
  return undefined;
};
export const updateUserThemeSetting = (themeName, themeMode) => {
  const themeEnum = getEnumFromTheme(themeName, themeMode);
  if (!themeEnum) {
    return Promise.reject(new Error('Invalid theme name or mode'));
  }
  return hubfulRpcClient.call(updateUserThemeSettingRpc, {
    request: {
      themeName: themeEnum
    }
  });
};